import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showDemoForm, setShowDemoForm] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleDemoClick = () => {
    scrollToSection('demo-form');
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-gray-900/80 backdrop-blur-md' : 'bg-transparent'
    }`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <span className="text-xl font-bold bg-gradient-to-r from-cyan-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">
              DataSync
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            <button
              onClick={() => scrollToSection('problem-section')}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('solution-section')}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Solution
            </button>
            <button
              onClick={() => scrollToSection('features-section')}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('stats-section')}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Stats
            </button>
            <button
              className="bg-cyan-500 hover:bg-violet-500 text-white px-4 py-2 rounded-lg font-medium transition-colors"
              onClick={handleDemoClick}
            >
              Book a Demo
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-gray-300 hover:text-white hover:bg-gray-800/50 transition-colors"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-gray-900/90 backdrop-blur-md rounded-lg mt-2 border border-gray-800/50">
              <button
                onClick={() => scrollToSection('problem-section')}
                className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-md transition-colors"
              >
                Why Us
              </button>
              <button
                onClick={() => scrollToSection('solution-section')}
                className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-md transition-colors"
              >
                Solution
              </button>
              <button
                onClick={() => scrollToSection('features-section')}
                className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-md transition-colors"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('stats-section')}
                className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-md transition-colors"
              >
                Stats
              </button>
              <button
                onClick={handleDemoClick}
                className="block w-full text-left px-3 py-2 bg-cyan-500 hover:bg-violet-500 text-white rounded-md transition-colors"
              >
                Book a Demo
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;